import { render } from "./interviewComponent.vue?vue&type=template&id=5ab80254"
import script from "./interviewComponent.vue?vue&type=script&lang=js"
export * from "./interviewComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__